import { useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import history from 'utils/history';
import { Helmet } from 'react-helmet';

import { UserContext } from 'contexts/UserContext';
import { useBrand, BRANDS } from 'hooks/useBrand';
import AV from 'images/favicon.ico';
import ECOSU from 'images/favicon-ecosu.ico';
import { metrika } from 'utils/metrika';
import { withTranslations } from 'utils/i18n';
import { ServiceNotificationModal } from 'components/ServiceNotificationModal';
import { ConfigProvider } from 'antd';
import { FeatureFlagModal } from 'features/flags';

import Report, { REPORT_URL, TestReport } from 'containers/Report';
import { ScrollToTop } from 'components/ScrollToTop';
import { useBrandFeatures } from 'hooks/useBrandFeatures';
import { useLoadConfig } from 'hooks/useConfig';
import { ServiceNotification } from 'features/serviceNotification';
import { MaintenancePage } from 'containers/SystemMaintenance';
import Main from './containers/Main/Main';
import './styles/index.scss';
import './App.scss';

ConfigProvider.config({
  theme: {
    primaryColor: '#4f637e'
  }
});

const FAVICONS: Record<BRANDS, string> = {
  [BRANDS.AV]: AV,
  [BRANDS.ECOSU]: ECOSU,
  [BRANDS.WODOMAT]: AV
};

function Root() {
  const isLoading = useLoadConfig();

  const brand = useBrand();

  useEffect(
    () =>
      history.listen((l) => {
        metrika.hit(l.pathname);
      }),
    []
  );

  const features = useBrandFeatures();

  return (
    <>
      <ServiceNotification />
      <Router history={history}>
        <Switch>
          <Route path="/maintenance" exact component={MaintenancePage} />
          <Route path={REPORT_URL} exact>
            <Report />
          </Route>
          <Route path={`${REPORT_URL}/test`} exact>
            <TestReport />
          </Route>
          <Route>
            <UserContext>
              {features.services && <ServiceNotificationModal />}
              {!isLoading && <Main />}
            </UserContext>
          </Route>
        </Switch>
        <Helmet>
          <link rel="shortcut icon" href={FAVICONS[brand]} />
        </Helmet>
        <ScrollToTop />
      </Router>
      <FeatureFlagModal />
    </>
  );
}

export const App = withTranslations(Root);
